<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'TEAM.UPDATE' | translate }}</div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    @if (show) {
      <form [formGroup]="form" class="form-grid">
        <div>
          <label>{{ 'TEAM.MEMBER' | translate }} ID</label>
          <a>{{ team.teamMemberId }}</a>
        </div>
        <div>
          <label>{{ 'TEAM.FIRST_NAME' | translate }}</label>
          <df-input block formControlName="teamMemberFirstName" />
        </div>
        <div>
          <label>{{ 'TEAM.LAST_NAME' | translate }}</label>
          <df-input block formControlName="teamMemberName" />
        </div>
        <div>
          <label>{{ 'TEAM.LANGUAGE' | translate }}</label>
          <df-input block formControlName="teamMemberLanguage" />
        </div>
        <div>
          <label>{{ 'TEAM.PHONE' | translate }}</label>
          <df-input block formControlName="teamMemberCellularPhone" />
        </div>
        <div>
          <label>{{ 'TEAM.EMAIL' | translate }}</label>
          <df-input block formControlName="teamMemberEmail" />
        </div>
        <div>
          <label>{{ 'TEAM.LOCATION' | translate }}</label>
          <df-select formControlName="peoplelocationcode"
            [options]="peopleLocations | selectOptions:'peoplelocationcode':'peoplelocationname'" />
        </div>
        <div>
          <label>{{ 'TEAM.MOBILE_DEVICE' | translate }}</label>
          <df-select formControlName="mobileDevicepk" [options]="mobileDeviceOptions" />
        </div>
        @for (role of roles; track role) {
          <div>
            <label>{{ role }}</label>
            <input type="checkbox" [checked]="hasRole(role)" (change)="updateRole($event, role)"/>
          </div>
        }
      </form>
    }

    <div class="footer">
      <df-button variant="primary" (onClick)="update()" [disabled]="form.invalid">{{ 'UPDATE' | translate }}</df-button>
    </div>

  </div>
</div>